


import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { AccountTabletLinkovi } from '../../Components/Account/AccountTabletLinkovi.jsx'
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx'


import { CasinoLink } from '../../Components/Layout/CasinoLink.jsx'
import { Wallet2 } from '../../Components/Account/Wallet2.jsx'
import { AccountLinkovi } from '../../Components/Account/AccountLinkovi.jsx'

export  class AccountGameDetails extends React.Component {

    constructor(props) {
        super(props);

        this.fetchMore = this.fetchMore.bind(this);
        this.state = casino.states["games-details"] || {
            working: true,
            data: null,
            page: 1
        };

        this.getDetails = this.getDetails.bind(this);
        this.setDetails = this.setDetails.bind(this);

        if (!casino.states["games-details"])
            this.getDetails();
    }



    getDetails() {
        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.playerGameDetailsRepo.get(this.props.route.match.params.providerId, this.props.route.match.params.gameId, 1)]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setDetails, function (reason) { });
    }

    setDetails(data) {
        this.setState({ info: data[0], data: data[0].items, hasMore: data[0].hasMore, working: false })
        this.props.showLoadingFn(false);
    }


    componentWillUnmount() {
        this.props.showLoadingFn(false);

    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    fetchMore() {
        var that = this;
        this.props.showLoadingFn(true);
        var page = (this.state.page + 1)
        this.setState({ working: true });

        casino.repos.playerGameDetailsRepo.get(this.props.route.match.params.providerId, this.props.route.match.params.gameId, page).then(function (data) {
            that.setState({ info: data, data: that.state.data.concat(data.items), working: false, hasMore: data.hasMore, page: page })
            that.props.showLoadingFn(false);
        });
    }


    renderTran(x) {
        var providerId = this.props.route.match.params.providerId;
        var gameId = this.props.route.match.params.gameId;

        return <tr key={x.id} className="horizontal-lines">
            <td>
                <div className="game-played">
                    <span className="text">{x.game}</span>
                </div>
            </td>
            <td><span className="text-left">{casino.utils.dateToDateString(new Date(x.datum))} {casino.utils.dateToTimeString(new Date(x.datum))}</span></td>
            <td className="text-right text-bold">
                <div className="main-currency">{casino.utils.numberWithCurrencyFromated(x.bet,x.valuta)}</div>
            </td>
            <td className="text-right text-bold">
                <div className="main-currency">{casino.utils.numberWithCurrencyFromated(x.win,x.valuta)}</div>
            </td>

            <td className="text-center">
                <NavLink style={{ 'color': '#333', fontSize: '16px' }} onClick={() => casino.states["games-details"] = this.state} to={this.props.getHomePathFn(this.props.route.location, '/account/games/' + providerId + '/' + gameId + '/' + x.id)}>
                    <span className="icon ico-info " style={{ padding: '0 3px' }}></span>
                </NavLink>
            </td>
        </tr>
    }



    render() {

        var pathName = this.props.route.match.url;
        var user = this.props.user;



        if (this.props.user) {
            return <div>

               {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}

                <Route exact path={pathName} render={(route) =>
                    (<Header key="header"  {...this.state} {...this.props} detailsHeader="true" headerText={"Vrtnje"} headerBackUrl={this.props.getHomePathFn(this.props.route.location, '/account')}></Header>)} />

                <div className="flex margin-1p-on-tablet">
                    <AccountTabletLinkovi {...this.props} ></AccountTabletLinkovi>

                    <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding" style={{ minHeight: '400px' }}>



                        <div className="header-2">
                            <h1 className="text">{this.state.info && this.state.info.game}</h1>
                        </div>
                        <div className="clearfix flex-equal-size maximum">
                            <div className="" style={{ minHeight: '600px' }}>
                                <div className="padding-sides-medium ">
                                    <br></br>
                                    <table style={{ maxWidth: '450px' }}>
                                        <tbody>
                                            <tr>
                                                <td>Igra:</td>
                                                <td><b>{this.state.info && this.state.info.game}</b></td>
                                            </tr>

                                            <tr>
                                                <td>Ulog:</td>
                                                <td><b>{this.state.info && casino.utils.numberWithCurrencyFromated(this.state.info.bet, this.state.info.valuta)}</b>
                                                
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Dobitak:</td>
                                                <td><b>{this.state.info && casino.utils.numberWithCurrencyFromated(this.state.info.win,this.state.info.valuta)}</b>
                                                
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Broj vrtnji:</td>
                                                <td><b>{this.state.info && this.state.info.rounds}</b></td>
                                            </tr>
                                            <tr>
                                                <td>Početak:</td>
                                                <td><b>{this.state.info && (casino.utils.dateToDateString(new Date(this.state.info.openDate)) + ' ' + casino.utils.dateToTimeString(new Date(this.state.info.openDate)))}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <br />

                                    <hr />
                                    <br />
                                    {this.state.info && this.state.info.provider != 42 && <div>

                                        <b className="text">Vrtnje:</b>
                                        <br />
                                        <br />

                                        {this.state.data && this.state.data.length == 0 && <span className="text">Nema igara.</span>}
                                    </div>}

                                    {this.state.info && this.state.info.provider == 42 && <div>
                                        <span className="text">Podaci su dostupni na vašem računalu.</span>
                                    </div>}
                                </div>
                                {this.state.data && this.state.data.length > 0 &&
                                    <table className="table-1 v2 v3 played-games" >
                                        <thead><tr>
                                            <th className="text-left text text-6">Igra</th>
                                            <th className="  text-left text text-6 ">Datum</th>
                                            <th className="text-right text text-6">Ulog</th>
                                            <th className="text-right text text-6">Dobitak</th>
                                            <th className="text-right text text-6"></th>

                                        </tr></thead>
                                        <tbody>
                                            {this.state.data.map(this.renderTran.bind(this))}
                                        </tbody>
                                    </table>
                                }


                                {this.state.hasMore &&
                                    <div className="text-center" >
                                        <br></br>
                                        <button disabled={this.state.working} className="btn fill medium gray-blue" onClick={this.fetchMore}> Učitaj još... </button>
                                        <br></br>
                                    </div>
                                }

                                {this.state.data && this.state.data.length > 0 &&
                                    <div className="padding-sides-medium margin-top text-center">
                                        <span style={{ fontStyle: 'italic', fontSize: '12px' }}>
                                            *detalje možete ispisati na vašem računalu</span>
                                    </div>
                                }

                                <br></br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } else {
            return <div>
                <Header key="header" {...this.state} {...this.props}></Header>
                <RestrictedAccess {...this.props} />


                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}


            </div>

        }
    }
};
